import { Link } from 'react-router';
import { CONTACT } from '../features/landing/SiteChrome';
import { PolicyLayout } from '../features/landing/PolicyLayout';
import { POLICIES_UPDATED } from './Privacy';

export function Terms() {
  return (
    <PolicyLayout
      title="Terms of use"
      updated={POLICIES_UPDATED}
      intro={
        <p>
          The ground rules for using Roadrunner, in plain language. By creating an account, you agree to these terms and
          the <Link to="/guidelines">community guidelines</Link>.
        </p>
      }
    >
      <h2>Who can use Roadrunner</h2>
      <ul>
        <li>You must be 18 or older and live in the area Roadrunner serves.</li>
        <li>One account per person, in your own name.</li>
        <li>Verify your location honestly, from your home. Faking your location isn’t allowed.</li>
      </ul>

      <h2>What you post</h2>
      <ul>
        <li>
          You own what you post. You give Roadrunner permission to store it and show it to your neighbors, which is how
          the board works. That permission ends when you delete the post or your account.
        </li>
        <li>
          You’re responsible for what you post. Only post things you have the right to share, and follow the{' '}
          <Link to="/guidelines">community guidelines</Link>.
        </li>
      </ul>

      <h2>Moderation</h2>
      <p>
        Roadrunner may remove posts, and suspend or close accounts, that break these terms or the guidelines. We try to
        be fair and consistent, and you can always <a href={`mailto:${CONTACT.email}`}>ask for another look</a>.
      </p>

      <h2>What Roadrunner is, and isn’t</h2>
      <ul>
        <li>
          Roadrunner is a small, free project. Features may change, the site may occasionally be down, and it may
          someday shut down. If it does, members will get notice first.
        </li>
        <li>
          Notes are written by neighbors. Roadrunner doesn’t check what they say, including recommendations and alerts.
          Use your own judgment.
        </li>
        <li>Roadrunner is not an emergency service. In an emergency, call 911.</li>
        <li>
          Roadrunner is provided “as is,” without warranties. To the extent the law allows, Roadrunner isn’t liable for
          indirect or consequential losses from using it, or for what other members post or do.
        </li>
      </ul>

      <h2>Leaving</h2>
      <p>
        You can delete your account at any time from the <Link to="/me">Me</Link> page. How your information is handled
        is covered in the <Link to="/privacy">privacy policy</Link>.
      </p>

      <h2>Changes and law</h2>
      <p>
        These terms may change. If they do, this page will be updated and significant changes will be announced on the
        site. These terms are governed by the laws of Arizona.
      </p>

      <h2>Contact</h2>
      <p>
        Roadrunner is run by Nicholas De Leon in Catalina, Arizona.{' '}
        <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
      </p>
    </PolicyLayout>
  );
}
